export const moduleHasManuallySetComplete = (value: undefined | boolean) => {
  return {
    type: 'MODULE_WAS_MANUALLY_SET_COMPLETE',
    data: value,
  };
};
